module.exports = __webpack_public_path__ + "static/media/loading.efe25fa5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.svg
// module id = 104
// module chunks = 0